import { FormattedEvent, isPromoCodeActive } from '@eventbrite/event-renderer';

export type DiscoverEventCardAvailableSignals =
    | 'urgencySignals'
    | 'discountCode'
    | 'BOGOLabel';

export function getEventCardSignalsVisibility({
    event,
    withLimitedVisibility,
    showOpenDiscounts,
}: {
    event: FormattedEvent;
    withLimitedVisibility: boolean;
    showOpenDiscounts?: boolean;
}) {
    if (!withLimitedVisibility) {
        return {
            showUrgencySignals: true,
            showDiscountCode: showOpenDiscounts,
            showBOGOLabel: true,
        };
    }

    if (event.specialDiscounts?.hasBogoTickets) {
        return {
            showUrgencySignals: false,
            showDiscountCode: false,
            showBOGOLabel: true,
        };
    }

    if (isPromoCodeActive(event.openDiscount) && showOpenDiscounts) {
        return {
            showUrgencySignals: false,
            showDiscountCode: true,
            showBOGOLabel: false,
        };
    }

    return {
        showUrgencySignals: true,
        showDiscountCode: false,
        showBOGOLabel: false,
    };
}
